import { render, staticRenderFns } from "./BlockRenderOverview.vue?vue&type=template&id=70cb7cec"
import script from "./BlockRenderOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockRenderOverview.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports